var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"mb-0 justify-space-between pl-3"},[_c('v-list-item-avatar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }